export const shop = (state = { items: [] }, action) => {
  if (action.type === "SHOP_ADD_TO_CART") {
    // Wenn der Artikel schon vorhanden ist
    if (state.items.some((si) => si.item.id === action.item.id)) {
      //Wenn er in gleicher Anzahl vorhanden ist
      if (
        state.items.filter((si) => si.item.id === action.item.id)[0].amount ===
        action.amount
      ) {
        return state;
      } else {
        // Item mit aktuellem Amount ersetzen
        return {
          ...state,
          items: state.items.map((si) =>
            si.item.id !== action.item.id
              ? si
              : { item: action.item, amount: action.amount }
          ),
        };
      }
    }

    return {
      ...state,
      items: [...state.items, { item: action.item, amount: action.amount }],
    };
  }
  if (action.type === "SHOP_REMOVE_FROM_CART") {
    return {
      ...state,
      items: state.items.filter((_, index) => index !== action.index),
    };
  }

  return state;
};
